import React, { useContext, useEffect, useState } from "react";
import Counter from "./countertext";
import Footer from "./footer";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";




function Importexportlicenseieciec() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
         
        }));
      }
    }, []);


   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const[newData,setNewData]=useState({user_name:'',user_email_address:'',user_phone_number:'',user_category:''})

   const [errors, setErrors] = useState({});

      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 9);

   const validateForm = () => {
      const newErrors = {};

      // Name validation
      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      }   else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
       }

      // Email validation
      if (!newData.user_email_address.trim()) {
         newErrors.user_email_address = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
         newErrors.user_email_address = 'Enter a valid email address.';
      }

      // Phone number validation
      // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
      //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
      // }

      if (!newData.user_phone_number.trim()) {
         newErrors.user_phone_number = 'number is required.';
       } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
         newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
       }

      // Category validation
      if (!newData.user_category) {
         newErrors.user_category = 'Please select a category.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Return true if no errors
   };



   const formPutPartenshipdeed = async (e) => {
               e.preventDefault();
                   // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
               if (!validateForm()) return;
             
               localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                
             };

             const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};

   
   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">Import Export License (IEC)</h1>
                        <p className="pdrl-text">Get Import Export License (IEC) for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                        <p className="pd-text">Obtain your Import Export Code and launch your import-export business. Let Dm2Legal handle the IEC (Import Export Code) process, so you can focus on your future endeavors.</p>
                        <p className="pd-text">It is issued by the DGFT (Director General of Foreign Trade). This PAN-based registration with the DGFT remains valid until it is surrendered or canceled.</p>
                       <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>

                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only <br/> <span>(Final Price, No Hidden Costs)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label> {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <label for="" className="dropdown-text">Category<span className="red">*</span></label> {errors.user_category && <p className="error-text">{errors.user_category}</p>}
                                       <div className="niceSelect">
                                       <select className="wide" onChange={(e) => setNewData({ ...newData, user_category: e.target.value })} value={newData.user_category}>
                                             <option className="formop" data-display="Select Category...">Select Category...</option>
                                             <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                                             <option value="Partnership / LLP">Partnership / LLP</option>
                                             <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                                             <option value="HUF">HUF</option>
                                             <option value="Society / Trust / Club">Society / Trust / Club</option>
                                          </select>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">

               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text">An Import Export Code (IEC) is crucial for starting a global trade business. It is a mandatory license for importing or exporting goods from India, enabling seamless international transactions.</p>
                     <p className="pd-text">In today’s competitive world, businesses seek global expansion beyond domestic markets. Advancements in the internet and technology have made international trade more accessible and seamless than ever before.
                     </p>
                  </div>
               </div>
               <div className="space20"></div>

            </div>
         </div>



         <div className="service-binifits9 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/Import-Export-License-(IEC).png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">

                        <h2 className="text-center">Documents Required for IEC Registration </h2>
                     </div>
                  </div>
                  <div className="col-lg-8">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <p>For IEC Code Registration, the following documents are required:</p>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Individual’s or Firm’s or Company’s copy of PAN Card.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Individual’s voter ID or Aadhar card or passport copy.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Individual’s or company’s or firm’s cancel cheque copies of current bank accounts.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Copy of Rent Agreement or Electricity Bill Copy of the premise.</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
                  </div>
               </div>
             

               <div className="space20"></div>
            </div>
         </div>

         <div className="service-binifits9 sp0" id="service2" >
            <div className="space40"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Importance of IEC License for Import-Export Businesses  </h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Legal Requirement</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Compliance and Risk Management</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Identification and Tracking</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Product Selection and Categorization</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Global Trade Opportunities</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Risk Management</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Access to Benefits and Incentives</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Logistics and Shipping</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Building Credibility and Trust</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Export Promotion</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>

            </div>
         </div>

         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Common Mistakes to Avoid in IEC Registration  </h2>
                        <div className="space20"></div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="contact6-list doc-list">
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not following the Rules and Regulations</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not Submitting Accurate Information</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not Meeting Deadlines</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not Keeping Copies</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not Paying Attention To Details</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Providing Inaccurate Details</li>
                          
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/Common-Mistakes-to-Avoid-in-IEC-Registration.png" alt="" />
                     </div>
                  </div>

                  <div className="col-lg-4">
                     <div className="contact6-list doc-list">
                        <ul>
                           
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Overlooking White Spaces</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Poor Time Management Skills</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Neglecting to update Details</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Disregarding Technical Details</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Missing Complete Details for Import Code</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Underestimating the Importance of the Code Application Fee</li>
                        </ul>
                     </div>
                  </div>

               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Benefits of Online IEC License Application with Dm2Legal</h2>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
               <div className="row">
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-9.png" alt="" />
                        </div>
                        <h3>Global Market Reach</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>Online Registration</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Lets you avail export incentives</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-12.png" alt="" />
                        </div>
                        <h3>PAN-Based Registration</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-13.png" alt="" />
                        </div>
                        <h3>Lifetime Validity</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-14.png" alt="" />
                        </div>
                        <h3>No Compliance</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-15.png" alt="" />
                        </div>
                        <h3>No Need for Annual Maintenance</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-11.png" alt="" />
                        </div>
                        <h3>Legally Clean</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Lowers the Risk of Illegal Transportation</h3>
                     </div>
                  </div>
                  {/* <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Compete with or beat local players</h3>
                     </div>
                  </div> */}
                  {/* <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-11.png" alt="" />
                        </div>
                        <h3>Requirement of Simple Documents</h3>
                     </div>
                  </div> */}
               </div>



            </div>
         </div>


         <div className="service-binifits9 sp0" id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2>Process of IEC Code Registration </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li> <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our team of experts will thoroughly review all the documents you submit to minimize the risk of incorrect or misleading information, ensuring a smooth process.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our top import-export professionals are here to assist you with document requirements and licensing needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>The assigned professional will proceed with your documents to apply for your IEC.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>If your application and submitted documents are approved by the relevant department, your import-export business will be registered with the DGFT.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>We recommend waiting until one of our experts contacts you to confirm that your license is ready.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="bg-white">

            <div className="container ">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Online IEC Code Registration: Step-by-Step Guide  </h2>
                     </div>
                  </div>
                  <div className="col-lg-8">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 1:                           
                                 <p className="pd-text">Prepare the application in the required format, then submit it to the regional office of the DGFT.</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 2:                      
                                 <p className="pd-text">Next, prepare the required documents and complete the application.</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 3:                            
                                 <p className="pd-text">Once completed, submit the application to the DGFT using a Digital Signature Certificate (DSC).</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 4:                              
                                 <p className="pd-text">Finally, once the application is approved, you will receive your IEC Code.</p>                              
                              </li>
                              
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="space30"></div>
                     <img src="assets/img/images/Online-IEC-Code-Registration-Step-by-Step-Guide.png" alt="" />
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs on Import Export License </h2>
                              <div className="space20"></div>


                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >  Q1. What is an Import Export Code (IEC)?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The Import Export Code (IEC) is a 10-digit license issued by the DGFT, mandatory for businesses involved in importing or exporting goods and services in India.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2. How can you apply for an Import Export Code (IEC)?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Apply for an IEC online through the DGFT portal, submit PAN, address proof, bank details, and pay the required fee to get approval.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3. Which documents are required for an IEC application?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Key documents include PAN card, Aadhaar or passport, business address proof, bank certificate or canceled cheque, and a digital signature (if required).                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4. Is IEC renewal mandatory?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, IEC must be updated every year on the DGFT portal, even if there are no changes. Failure to update may lead to deactivation.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5. Can an individual obtain an IEC?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, an individual can apply for an IEC using their PAN, Aadhaar, and bank details, even without a registered business.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6. How long does it take to get an IEC?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       IEC is usually issued within 2 to 7 working days after successful application submission and document verification on the DGFT portal.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7. Is IEC required for exporting services?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       IEC is mandatory for service exports if receiving payments under Foreign Trade Policy benefits, otherwise, it's optional for general service exports.
                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8. Can a single IEC be used for multiple branches?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, a single IEC is valid for all branches of the company, covering imports and exports across multiple locations in India.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9. What if my IEC is lost?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       If you lose your IEC, you can retrieve it by logging into the DGFT portal and re-downloading the certificate using your credentials.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10. How many IEC codes can a person or entity have in India?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Only one IEC is allowed per PAN. Multiple IECs for the same individual or entity are not permitted. 
                                       </p>
                                    </div>
                                 </div>








                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>

         <Testimonials />



         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">

                        <h2>Why Choose Dm2Legal for IEC Registration?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient IEC Registration</a></h4>
                           <p>With Dm2Legal, users can easily register online by providing their name, email ID, contact number, and selecting IEC registration services. After completing your online registration, our team will reach out to you and proceed with the necessary steps.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal has one of the largest online client bases, making us one of the best online platforms in India to help you obtain your IEC registration quickly. No matter where you are, we are ready to serve you online.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is well-known for providing comprehensive support and assistance to our clients. We not only assist you after your registration is completed but also value your feedback.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With 10 years of experience in the industry, we are highly skilled in IEC registration. By choosing us, you'll benefit from working with top experts, ensuring a smooth and efficient registration process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is always ready to provide timely service. We understand the value of your time, so we begin working on your IEC registration process immediately, without any delays.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We offer affordable services without compromising on quality. With every investment you make with us, we ensure that your satisfaction and budget are our top priorities.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>


         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />
      </div>

   );
}
export default Importexportlicenseieciec;